<template>
    <div class="content">
        <div class="content-head" v-if="showQuery">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="收货地址" v-if="isFiltration && pageType != 'returnManagement'">
                    <el-select v-model="params.Orders_Address_Country" placeholder="请选择国家" class="el-select-mini">
                        <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_Province" placeholder="请选择省" class="el-select-mini" @change="provinceChange" clearable filterable>
                        <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_City" placeholder="请选择市/地区" class="el-select-mini" @change="cityChange" clearable filterable>
                        <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                    &nbsp;
                    <el-select v-model="params.Orders_Address_District" placeholder="请选择区/县" class="el-select-mini" clearable filterable>
                        <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同日期" v-if="isFiltration">
                    <el-date-picker v-model="params.date_start" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                    <span style="margin: 0 5px">至</span>
                    <el-date-picker v-model="params.date_end" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" clearable></el-date-picker>
                </el-form-item>
                <el-form-item label="合同类型">
                    <el-select v-model="params.orders_tradetype" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in orders_tradetype_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="付款方式">
                    <el-select v-model="params.paytype" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部合同" :value="0" :title="'全部合同'">
                            <el-tooltip effect="dark" :content="'全部合同'" placement="right">
                                <span class="ellipsis-option">全部合同</span>
                            </el-tooltip>
                        </el-option>
                        <el-option v-for="item in paytype_opt" :key="item.Pay_Type_ID" :label="item.Pay_Type_Name" :value="item.Pay_Type_ID">
                            <el-tooltip effect="dark" :content="item.Pay_Type_Name" placement="right">
                                <span class="ellipsis-option">{{ item.Pay_Type_Name }}</span>
                            </el-tooltip>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同纸状态">
                    <el-select v-model="params.RecoverStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in RecoverStatus_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="报价单来源类型" v-if="isFiltration && pageType === 'allContracts'">
                    <el-select v-model="params.SPCApply_SourceType" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in SPCApply_SourceType_opt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="BPM审核状态" v-if="pageType === 'returnManagement'">
                    <el-select v-model="params.orders_bpmauditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in orders_bpmauditstatus_List" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="电子签章状态">
                    <el-select v-model="params.Orders_ESignStatus" placeholder="请选择" class="el-select-medium">
                        <el-option v-for="item in Orders_ESignStatus_List" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" 折扣分组" v-if="isFiltration && pageType != 'returnManagement'">
                    <el-select v-model="params.Orders_DiscountCate" placeholder="请选择" class="el-select-medium" value-key="Code">
                        <el-option value="">全部折扣分组</el-option>
                        <el-option v-for="item in Orders_DiscountCateOpt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务员">
                    <el-input v-model="params.officeman" autocomplete="on" name="officeman" style="width: 150px" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="关键词">
                    <el-input v-model="params.keyword" autocomplete="on" name="keyword" style="width: 450px" :placeholder="pageType == 'returnManagement' ? '输入合同号、纸质合同号、上上签合同编号、客户名称、工程名称进行搜索' : '输入合同号、纸质合同号、上上签合同编号、客户名称、工程名称、收货人姓名进行搜索'" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="商品名称" v-if="isFiltration">
                    <el-input v-model="params.product_name" autocomplete="on" name="productname" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="原ERP订单号" autocomplete="on" name="Orders_SourceERPSN" v-if="pageType === 'returnManagement'">
                    <el-input v-model="params.Orders_SourceERPSN" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="报价单编号" autocomplete="on" name="apply_sn" v-if="pageType === 'allContracts'">
                    <el-input v-model="params.apply_sn" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>
                <el-form-item label="商机编号" autocomplete="on" name="pipelinecode" v-if="isFiltration && pageType === 'allContracts'">
                    <el-input v-model="params.pipelinecode" placeholder="请输入" clearable class="el-select-medium"></el-input>
                </el-form-item>

                   <el-form-item label="下单时间" v-if="isFiltration">
                    <el-select v-model="params.addtime" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="0"></el-option>
                        <el-option label="7天以内" :value="7"></el-option>
                        <el-option label="15天以内" :value="15"></el-option>
                        <el-option label="30天以内" :value="30"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同状态"  v-if="isFiltration">
                    <el-select v-model="params.orders_status" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option label="未提交" :value="0"></el-option>
                        <el-option label="正常" :value="1"></el-option>
                        <!-- <el-option label="交易成功" :value="2"></el-option> -->
                        <el-option label="已取消" :value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="审核状态"  v-if="isFiltration">
                    <el-select v-model="params.orders_auditstatus" placeholder="请选择" class="el-select-medium">
                        <el-option label="全部" :value="-1"></el-option>
                        <el-option :label="pageType === 'returnManagement' ? '待审核' : '待审核'" :value="pageType === 'returnManagement' ? 0 : 0"></el-option>
                        <el-option :label="pageType === 'returnManagement' ? '已下达' : '已下达'" :value="pageType === 'returnManagement' ? 1 : 1"></el-option>
                        <el-option :label="pageType === 'returnManagement' ? '审核失败' : '审核失败'" :value="pageType === 'returnManagement' ? 2 : 2"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="getSPCOrders(true)" icon="el-icon-search" :loading="loadingBtn">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onRefresh" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="setFiltration" :icon="!isFiltration ? 'el-icon-arrow-down' : 'el-icon-arrow-up'">
                        {{ !isFiltration ? '展开' : '收起' }}
                    </el-button>
                </el-form-item>
            </el-form>

           
        </div>
        <div class="content-table">
            <div class="content-table-title" v-if="showQuery">
                {{ pageType === 'returnManagement' ? '退货申请管理' : '全部合同列表' }}
                <span>
                    <!-- <el-button v-if="pageType === 'returnManagement'" type="primary"
                        @click="getApplyOrder()">申请退货</el-button> -->
                    <el-dropdown trigger="click" style="margin-left: 10px; margin-right: 10px">
                        <el-button>
                            导出
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(1)">导出勾选合同信息</span>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="getPipelineApplysExport(2)">导出结果合同信息</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </span>
            </div>
            <el-table :data="tableData" @row-click="handleRowMultipleClick" :row-class-name="tableRowMultipleClassName" @selection-change="handleSelectionChange" :height="maxheight" ref="multipleTable" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }" v-loading="loadingBtn">
                <el-table-column v-if="showQuery" align="center" type="selection" width="40" fixed></el-table-column>
                <!-- <el-table-column prop="Orders_ID" label="ID" align="center" fixed></el-table-column> -->
                <el-table-column prop="Orders_ProjectName" show-overflow-tooltip label="工程名称" align="center" min-width="220" fixed></el-table-column>
                <el-table-column prop="Orders_SN" label="合同号" align="center" :width="pageType === 'allContracts' ? 170 : 150"></el-table-column>
                <el-table-column prop="Orders_Addtime" show-overflow-tooltip label="下单时间" align="center" width="120">
                    <template slot-scope="scope">
                        <span>{{ scope.row.Orders_Addtime | formatDate }}</span>
                    </template>
                </el-table-column>
                

                <el-table-column prop="Orders_CustomerName" show-overflow-tooltip min-width="220" label="客户名称" align="center"></el-table-column>
                <el-table-column prop="Orders_Total_AllPrice" label="合同总额" align="center" width="100" show-overflow-tooltip>
                    <template slot-scope="scope">￥{{ scope.row.Orders_Total_AllPrice }}</template>
                </el-table-column>
                <el-table-column prop="Orders_Status" label="合同状态" align="center" width="80">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_Status)">{{ scope.row.Orders_Status }}</span>
                    </template>
                </el-table-column>
                <el-table-column :prop="pageType === 'returnManagement' ? 'Orders_ESignStatusName' : 'Orders_AuditStatus'" show-overflow-tooltip label="审核状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span :class="judgeColor(pageType === 'returnManagement' ? scope.row.Orders_AuditStatus : scope.row.Orders_AuditStatus)">
                            {{ pageType === 'returnManagement' ? scope.row.Orders_AuditStatus : scope.row.Orders_AuditStatus }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :prop="pageType === 'returnManagement' ? 'BackBillStatusName' : 'Orders_BPMAuditStatus'" show-overflow-tooltip label="BPM审核状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span :class="judgeColor(pageType === 'returnManagement' ? scope.row.Orders_BPMAuditStatus : scope.row.Orders_BPMAuditStatus)">
                            {{ pageType === 'returnManagement' ? scope.row.Orders_BPMAuditStatus : scope.row.Orders_BPMAuditStatus }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :prop="pageType === 'returnManagement' ? 'RecoverStatusName' : 'Orders_RecoverStatus'" show-overflow-tooltip label="合同纸状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span :class="judgeColor(pageType === 'returnManagement' ? scope.row.Orders_RecoverStatus : scope.row.Orders_RecoverStatus)">
                            {{ pageType === 'returnManagement' ? scope.row.Orders_RecoverStatus : scope.row.Orders_RecoverStatus }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column :prop="pageType === 'returnManagement' ? 'BackBillSyncStatusName' : 'Orders_ESignStatusName'" show-overflow-tooltip label="电子签章状态" align="center" width="100">
                    <template slot-scope="scope">
                        <span :class="judgeColor(scope.row.Orders_ESignStatusName)">
                            {{ scope.row.Orders_ESignStatusName }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Orders_EsignContractID" show-overflow-tooltip label="上上签合同号" align="center" width="150"></el-table-column>
                <el-table-column prop="OfficeUserName" label="业务员" align="center" show-overflow-tooltip></el-table-column>
                
                
                <el-table-column v-if="pageType === 'allContracts'" prop="Orders_SPCSourceName" min-width="120" label="来源类型" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Orders_SourceType" show-overflow-tooltip label="来源" align="center" width="90"></el-table-column>
                <el-table-column label="操作" align="center" :width="pageType === 'allContracts' ? 200 : 120" fixed="right">
                    <template slot-scope="scope">
                        <div class="operation-bar">
                            <span class="operation-bar-block" @click="handleViewsDetail(scope.row)">查看</span>
                            <span class="operation-bar-block" v-if="scope.row.IsAppend" @click="pageType === 'returnManagement' ? handleViewsDetail(scope.row) : SPCApplyToSPCOrdersCheck(scope.row, '追加')">追加</span>
                            <span class="operation-bar-block" v-if="scope.row.IsCopy" @click="pageType === 'returnManagement' ? handleViewsDetail(scope.row) : SPCApplyToSPCOrdersCheck(scope.row, '复制')">复制</span>
                            <span class="operation-bar-block" @click="handleViewsDetailToNewWindow(scope.row)">新窗口查看</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div>
                <Pagination :paginationOptions="paginationOptions" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
            </div>
        </div>
        <el-dialog v-if="pageType === 'returnManagement'" title="选择订单" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" :before-close="dialogBeforeClose">
            <div>
                <el-form ref="form" label-width="120px">
                    <el-form-item label="ERP订单号">
                        <el-input v-model="Orders_SN" class="el-select-max" clearable></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" style="text-align: center">
                <el-button type="primary" @click="onNext()">下一步</el-button>
            </div>
        </el-dialog>
        <packOrderDetails v-if="pageType === 'returnManagement'" :isdetails="isdetails" :id="id" @handleClose="handleClose" />
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import { formatDate, downloadFile } from '@/utils/utils.js';
import { myMixin } from '@/utils/mixin.js';
import { mapState } from 'vuex';

// 仅在退货管理页面需要导入
let packOrderDetails = null;
if (
    require
        .context('@/views/contractreturnManagement/component', false, /\.vue$/)
        .keys()
        .includes('./packOrderDetails.vue')
) {
    packOrderDetails = () => import('@/views/contractreturnManagement/component/packOrderDetails.vue');
}

export default {
    name: 'contractmanagementAll',
    mixins: [myMixin],
    components: {
        Pagination,
        packOrderDetails
    },
    props: {
        showQuery: {
            type: Boolean,
            default: true
        },
        projectName: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        })
    },
    data() {
        return {
            pageType: 'allContracts', // 'returnManagement' 或 'allContracts'
            id: 0,
            isdetails: false,
            loadingBtn: false,
            dialogVisible: false,
            Orders_SN: '',
            params: {
                Orders_Address_Country: '',
                Orders_Address_District: '',
                Orders_Address_Province: '',
                Orders_Address_City: '',
                date_start: '',
                date_end: '',
                orders_tradetype: 0,
                paytype: 0,
                RecoverStatus: 0,
                SPCApply_SourceType: 0,
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0,
                Orders_DiscountCate: '',
                officeman: '',
                keyword: this.showQuery ? '' : this.projectName,
                product_name: '',
                Orders_SourceERPSN: '',
                apply_sn: '',
                pipelinecode: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_status: -1,
                Orders_SourceCate: 0
            },
            Orders_DiscountCateOpt: [],
            tableData: [],
            cityListopt: [],
            districtListopt: [],
            orders_tradetype_opt: [
                { label: '全部合同', value: 0 },
                { label: '销售合同', value: 1 },
                { label: '服务和物联网合同', value: 2 },
                { label: '返货合同', value: 3 }
            ],
            paytype_opt: [],
            orders_bpmauditstatus_List: [
                { name: '全部', value: 0 },
                { name: '待送审', value: 1 },
                { name: '审核中', value: 2 },
                { name: '已审核', value: 3 },
                { name: '审核失败', value: 4 },
                { name: '送审失败', value: -1 }
            ],
            Orders_ESignStatus_List: [
                { name: '全部', value: 0 },
                { name: '不需要', value: 1 },
                { name: '电子签章订单', value: -1 },
                { name: '待同步', value: 2 },
                { name: '发送失败', value: 3 },
                { name: '海湾签章失败', value: 4 },
                { name: '待客户签署', value: 5 },
                { name: '客户签署完成', value: 6 },
                { name: '客户拒签', value: 7 },
                { name: '逾期未签署', value: 8 },
                { name: '客户签署失败', value: 9 },
                { name: '已撤回', value: 10 }
            ],
            RecoverStatus_opt: [
                { label: '全部合同', value: 0 },
                { label: '不需要回收订单', value: 1 },
                { label: '待回收订单', value: 2 },
                { label: '已回收订单', value: 3 }
            ],
            SPCApply_SourceType_opt: [
                { label: '全部', value: 0 },
                { label: 'SPC报价单', value: 1 },
                { label: '非SPC报价单', value: 3 },
                { label: '系统生成报价单', value: 2 }
            ],
            multipleSelection: [],
            comfir_orders_id: '' // 保存合同的id
        };
    },
    created() {
        // 根据路由确定页面类型
        this.pageType = this.$route.path.includes('contractreturnManagement') ? 'returnManagement' : 'allContracts';

        // 根据页面类型设置初始值
        if (this.pageType === 'returnManagement') {
            this.params.Orders_SourceCate = 1;
            this.id = 272; // 退货管理页面特有的初始值
        } else {
            this.params.Orders_SourceCate = 0;
        }
    },
    mounted() {
        const e = this.$route.query || '';

        // 处理路由参数
        if (e) {
            if (e.Orders_SourceCate) {
                this.params.Orders_SourceCate = +e.Orders_SourceCate;
            }
            if (e.orders_status) {
                this.params.orders_status = +e.orders_status;
            }
            if (e.orders_auditstatus) {
                this.params.orders_auditstatus = +e.orders_auditstatus;
            }
            if (e.RecoverStatus) {
                this.params.RecoverStatus = +e.RecoverStatus;
            }
            if (e.Orders_ESignStatus) {
                this.params.Orders_ESignStatus = +e.Orders_ESignStatus;
            }
        }

        // 初始化数据
        this.getOrdersPayTypes();
        this.getDiscountCategorys();
        this.$store.dispatch('fetchLocationData');

        // 页面特定初始化
        if (this.pageType === 'returnManagement') {
            this.onRefresh(e);
        } else {
            this.getSPCOrders();
            if (sessionStorage.getItem('ContractPreservation')) {
                const savedData = JSON.parse(sessionStorage.getItem('ContractPreservation'));
                if (savedData) {
                    this.comfir_orders_id = savedData.orders_id;
                    sessionStorage.setItem('ContractPreservation', '');
                }
            }
        }
    },
    methods: {
        handleSizeChange(newSize) {
            this.paginationOptions.PageSize = newSize;
            this.getSPCOrders();
        },
        handleCurrentChange(newPage) {
            this.paginationOptions.Page = newPage;
            this.getSPCOrders();
        },
        //重置
        onRefresh(e) {
            // 重置参数
            this.params = {
                Orders_Address_Country: '',
                Orders_Address_District: '',
                Orders_Address_Province: '',
                Orders_Address_City: '',
                date_start: '',
                date_end: '',
                orders_tradetype: 0,
                paytype: 0,
                RecoverStatus: 0,
                SPCApply_SourceType: 0,
                orders_bpmauditstatus: '',
                Orders_ESignStatus: 0,
                Orders_DiscountCate: '',
                officeman: '',
                keyword: '',
                product_name: '',
                Orders_SourceERPSN: '',
                apply_sn: '',
                pipelinecode: '',
                addtime: 0,
                orders_auditstatus: -1,
                orders_status: -1,
                Orders_SourceCate: this.pageType === 'returnManagement' ? 1 : 0
            };

            // 处理特定页面的参数
            if (e) {
                if (e.RecoverStatus) {
                    this.params.RecoverStatus = +e.RecoverStatus;
                }
            }

            this.getSPCOrders(true);
        },
        getSPCOrders(flag = false) {
            this.loadingBtn = true;
            if (flag) {
                this.paginationOptions = {
                    Page: 1,
                    total: 0,
                    PageSize: 40
                };
            }
            this.$newsApi.order
                .getSPCOrders(this.filteropt())
                .then((res) => {
                     //alert(res.data.Resultinfo);
                    if (res.data.Resultcode == 0) {
                        this.tableData = res.data.data;
                        this.paginationOptions.total = res.data.RecordCount;

                        // 全部合同页面特有的逻辑
                        if (this.pageType === 'allContracts' && this.comfir_orders_id) {
                            this.tableData.forEach((item, index) => {
                                if (this.comfir_orders_id == -1 && index == 0) {
                                    this.$nextTick(() => {
                                        this.$refs.multipleTable.toggleRowSelection(item, true);
                                    });
                                    // this.$message({
                                    //     message: '合同创建成功'
                                    // });
                                }
                                if (item.Orders_ID == this.comfir_orders_id) {
                                    this.$nextTick(() => {
                                        this.$refs.multipleTable.toggleRowSelection(item, true);
                                    });
                                    // this.$message({
                                    //     message: '合同创建成功'
                                    // });
                                }
                            });
                        }
                    }
                })
                .finally(() => (this.loadingBtn = false));
        },
        filteropt() {
            let params = { ...this.params };

            return { json: JSON.stringify(params), Page: this.paginationOptions.Page, PageSize: this.paginationOptions.PageSize };
        },
        //导出所有
        getPipelineApplysExport(e) {
            if (e == 1) {
                let json = [];
                json = this.multipleSelection
                    .map((item) => {
                        return item.Orders_ID;
                    })
                    .join();
                let loadingInstance = this.$loading(); // 显示 loading
                this.$newsApi.ExportSPCOrders({ json: json }).then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                });
            } else {
                let loadingInstance = this.$loading(); // 显示 loading
                this.$newsApi.ExportSPCOrdersAll(this.filteropt()).then((res) => {
                    this.$closeLoading(loadingInstance); // 关闭 loading
                    if (res.data.Resultcode == 0) {
                        downloadFile(res.data.data, res.data.Resultinfo);
                    }
                });
            }
        },
        handleViewsDetail(row) {
            // 生成带时间戳的URL确保每次都不同
            const timestamp = Date.now();
            const randomId = Math.random().toString(36).substr(2, 9);
            
            if (this.pageType === 'returnManagement') {
                // 通过redirect路径实现页面重新渲染
                this.$router.push({
                    path: '/redirect/contractreturnManagement/details',
                    query: {
                        id: row.Orders_ID,
                        _t: timestamp,
                        _r: randomId
                    }
                }).catch(err => {
                    // 忽略重复导航错误
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                    }
                });
            } else {
                this.id = row.BackBill_ID;
                // 通过redirect路径实现页面重新渲染
                this.$router.push({
                    path: '/redirect/orderManagement/contractmanagementDetails',
                    query: {
                        id: row.Orders_ID,
                        _t: timestamp,
                        _r: randomId
                    }
                }).catch(err => {
                    // 忽略重复导航错误
                    if (err.name !== 'NavigationDuplicated') {
                        console.error('Navigation error:', err);
                    }
                });
            }
        },
        handleViewsDetailToNewWindow(row) {
            // 生成带时间戳的URL确保每次都不同
            const timestamp = Date.now();
            const randomId = Math.random().toString(36).substr(2, 9);
            
            const route = this.$router.resolve({
                path: this.pageType === 'returnManagement' ? '/contractreturnManagement/details' : '/orderManagement/contractmanagementDetails',
                query: { 
                    id: row.Orders_ID,
                    _t: timestamp,
                    _r: randomId
                }
            });
            window.open(route.href, '_blank');
        },
        handleClose() {
            this.isdetails = false;
        },
        /*
        获取付款方式
        */
        getOrdersPayTypes() {
            const TradeType = 2;
            const Customer_Type = 0;
            const Customer_IsLimitPay = 0;
            this.$newsApi.order.GetAllPayTypes().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.paytype_opt = res.data.data;
                }
            });
        },
        /*
        选择省
        */
        provinceChange(e) {
            this.cityListopt = [];
            this.params.Orders_Address_City = '';
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市
        */
        cityChange(e) {
            this.districtListopt = [];
            this.params.Orders_Address_District = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
        },
        /*
        多选
        */
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
       
        // 退货管理页面特有方法
        getApplyOrder() {
            if (this.pageType !== 'returnManagement') return;
            this.Orders_SN = '';
            this.dialogVisible = true;
        },
        dialogBeforeClose() {
            this.dialogVisible = false;
        },
        onNext() {
            if (this.Orders_SN == '') {
                this.$message({
                    message: 'ERP订单号不能为空',
                    type: 'warning'
                });
                return;
            }

            this.$newsApi.getERPOrdersByERPSN({ Orders_ERPSN: this.Orders_SN }).then((res) => {});
        },
        getDiscountCategorys() {
            this.$newsApi.GetDiscountCategoryByType().then((res) => {
                if (res.data.Resultcode == 0) {
                    this.Orders_DiscountCateOpt = res.data.data;
                }
            });
        },
        // 全部合同页面特有方法
        SPCApplyToSPCOrdersCheck(row, type) {
            if (this.pageType !== 'allContracts') return;
            // 修改合同
            this.$confirm(`确定要${type}合同吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(async () => {
                    //  if (type == '复制') {
                    //     let { data: result } = await this.$newsApi.order.GetSPCOrdersCopyByOrders({
                    //         Orders_id: row.Orders_ID,
                    //         Orders_Copy: this.changeOrderType == 1 ? 1 : 0
                    //     });
                    //     if(result.Resultcode == 0){
                    //         this.$router.push({ path: '/customOrder', query: { CopyId: row.Orders_ID, submitChangeOrderTypes: type == '复制' ? 1 : 2 } });
                    //     }
                    // }else{
                    //    this.$router.push({ path: '/customOrder', query: { CopyId: row.Orders_ID, submitChangeOrderTypes: type == '复制' ? 1 : 2 } });
                    // }
                    let { data: result } = await this.$newsApi.order.GetSPCOrdersCopyByOrders({
                        Orders_id: row.Orders_ID,
                        Orders_Copy: this.changeOrderType == 1 ? 1 : 0
                    });
                    if (result.Resultcode == 0) {
                        this.$router.push({ path: '/customOrder', query: { CopyId: row.Orders_ID, submitChangeOrderTypes: type == '复制' ? 1 : 2 } });
                    }else if(type == '复制'){
                        this.$router.push({ path: '/customOrder', query: { CopyId: row.Orders_ID, submitChangeOrderTypes: type == '复制' ? 1 : 2 } });
                    }
                     else {
                        this.$alert(result.Resultinfo, '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        }).then(() => {
                            return;
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
        }
    }
};
</script>
<style>
.ellipsis-option {
    display: inline-block;
    max-width: 200px;
    /* 你可以根据实际情况调整宽度 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
}
.operation-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    gap: 0px;
    white-space: normal;
}
.operation-bar-block {
    font-size: 12px;
    cursor: pointer;
    border-radius: 3px;
    margin: 1px 0;
}
.content-head {
    padding: 15px 20px 5px 20px;
}
.el-form-item--small.el-form-item {
    margin-bottom: 5px;
}
</style>